<template>
  <div>
    <Headline />
    <div class="container-fluid step-loader">
      <Status img="contract_renew.svg" />
    </div>
  </div>
</template>

<script>
import Status from '../Status.vue';
import Headline from '../layout/Headline.vue';

export default {
    components: {
        Headline,
        Status,
    },
};
</script>
